import React from "react";
import { Box, Text, IcoMoon, ArrowUpIcon2, ArrowDownIcon } from "@usap/uicomponents";
import { BoxWithPointer } from "../common/StyledCSS";
import outsideClickHandler from "../Checkout/helper/outsideClickHandler";

export default function QtyDropDown({
  wrapperId = "qtyDropDownWrapper",
  childId = "qtyDropDown",
  dropDown,
  setDropDown,
  selectedValue,
  setSelectedValue,
  options,
  wrapperWidth,
  wrapperHeight,
  absoluteTop,
  item,
  index,
  disabled,
  changeProductQty = () => {}
}) {
  const wrapperIdUpdated = `${wrapperId}-${index}`;
  const childIdUpdated = `${childId}-${index}`;
  return (
    <Box
      id={wrapperIdUpdated}
      width={wrapperWidth}
      height={wrapperHeight}
      background={disabled ? "light-1" : "white"}
      border={{
        side: "all",
        color: "light-3"
      }}
      round="xsmall"
      onClick={() => {
        if (disabled) return "";
        outsideClickHandler(
          dropDown,
          [wrapperIdUpdated, childIdUpdated],
          () => {
            setDropDown(false);
          }
        );
        return setDropDown(!dropDown);
      }}
    >
      <BoxWithPointer
        id={childIdUpdated}
        direction="row"
        style={{
          position: "relative",
          flexGrow: 1,
          cursor: disabled ? "default" : "pointer"
        }}
      >
        <Box width="50%" align="center" justify="center">
          <Text size="small" color="dark-2">
            {disabled ? "" : selectedValue}
          </Text>
        </Box>
        <Box width="50%" background="light-1" align="center" justify="center">
          <IcoMoon icon={dropDown ? ArrowUpIcon2 : ArrowDownIcon} size="24px" />
        </Box>
        <Box
          style={{
            position: "absolute",
            display: dropDown ? "block" : "none",
            top: absoluteTop,
            left: 0,
            zIndex: 99
          }}
          width="100%"
          height={{ max: "192px" }}
          overflow="auto"
          background="white"
          border={{
            side: "all",
            color: "light-3"
          }}
          round="xsmall"
        >
          {Array(options)
            .fill(0)
            .map((_, arrIndex) => {
              return (
                <BoxWithPointer
                  key={arrIndex + 1}
                  align="center"
                  pad="8px"
                  border={{
                    side: "bottom",
                    color: "light-3"
                  }}
                  onClick={event => {
                    setDropDown(false);
                    if (item) setSelectedValue(item, String(arrIndex + 1));
                    else setSelectedValue(String(arrIndex + 1));
                    changeProductQty(String(arrIndex + 1));
                    event.stopPropagation();
                  }}
                >
                  <Text size="small" color="dark-2">
                    {String(arrIndex + 1)}
                  </Text>
                </BoxWithPointer>
              );
            })}
        </Box>
      </BoxWithPointer>
    </Box>
  );
}
